import React from 'react';
import { useTranslation } from 'react-i18next';
import styles from './TestimonialsSection.module.css';
import useScrollAnimation from '../../hooks/useScrollAnimation';

const testimonialsKeyMap = [
    {
        nameKey: 'testimonials.julian.name',
        locationKey: 'testimonials.julian.location',
        quoteKey: 'testimonials.julian.quote'
    },
    {
        nameKey: 'testimonials.eloy.name',
        locationKey: 'testimonials.eloy.location',
        quoteKey: 'testimonials.eloy.quote'
    },
    {
        nameKey: 'testimonials.martins.name',
        locationKey: 'testimonials.martins.location',
        quoteKey: 'testimonials.martins.quote'
    }
];

const TestimonialCard = ({ nameKey, locationKey, quoteKey }) => {
    const { t } = useTranslation();
    const cardRef = useScrollAnimation({ once: true });
    return (
        <div className={`${styles.testimonialCard} animate-on-scroll`} ref={cardRef}>
            <h3>{t(nameKey)}</h3>
            <p className={styles.location}>{t(locationKey)}</p>
            <p className={styles.quote}>{t(quoteKey)}</p>
        </div>
    );
};

const TestimonialsSection = () => {
    const { t } = useTranslation();
    const sectionRef = useScrollAnimation({ once: true });

    return (
        <section id="testimonials" className={`${styles.testimonialsSection} animate-on-scroll`} ref={sectionRef}>
            <div className="container">
                <h2 className={`section-title ${styles.sectionTitle}`}>{t('testimonials.sectionTitle')}</h2>
                <div className={styles.testimonialGrid}>
                    {testimonialsKeyMap.map((testimonial, index) => (
                        <TestimonialCard key={index} {...testimonial} />
                    ))}
                </div>
            </div>
        </section>
    );
};

export default TestimonialsSection;
